import React, { useEffect, useState } from 'react';
import { ToastContainer, toast, cssTransition } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Link } from 'react-router-dom';

import { APIHandler, BackImage, DataHandler, StorageHandler } from 'C4';
import { storageKeys } from 'settings';

const checkInputValidity = () => {
  const inputs = document.getElementsByTagName('input');
  const inputArray = [];
  const selects = document.getElementsByTagName('select');
  const selectArray = [];

  Array.from(inputs).forEach((input) => {
    inputArray.push(input);
  });

  Array.from(selects).forEach((select) => {
    selectArray.push(select);
  });

  return (
    inputArray.every((val) => val.checkValidity() === true) &&
    selectArray.every((val) => val.selectedIndex !== 0)
  );
};

const checkInputValidityFields = () => {
  const inputs = document.getElementsByTagName('input');
  const inputArray = [];
  const selects = document.getElementsByTagName('select');
  const selectArray = Array.from(selects);

  Array.from(inputs).forEach((input) => {
    inputArray.push(input);
  });

  const emptyFields = [];
  inputs.forEach((input) => {
    if (input.checkValidity() === false) {
      let name = input.name.replace(/reg_/g, '').replace(/_/g, ' ');
      if (name === 'custom 1') {
        name = 'salutation';
      }
      if (name === 'passwordConfirm') {
        name = 'confirm password';
      }
      emptyFields.push(name);
    }
  });

  selectArray.forEach((select) => {
    if (select.selectedIndex === 0) {
      let name = select.name.replace(/reg_/g, '').replace(/_/g, ' ');
      if (name === 'agency affiliation') {
        name = 'consortia affiliation';
      }
      emptyFields.push(name);
    }
  });

  return emptyFields;
};

const Zoom = cssTransition({
  enter: 'zoomIn',
  exit: 'zoomOut',
  duration: [500, 800],
});

const PreRegisterView = () => {
  const [userInput, setUserInput] = useState({
    reg_email: '',
    reg_first_name: '',
    reg_last_name: '',
    reg_agency_name: '',
    reg_agency_affiliation: '',
    reg_country: '',
  });
  const [logo, setLogo] = useState(null);

  const changeHandler = (event) => {
    const input = userInput;
    input[event.target.name] = event.target.value || event.target.checked;
    setUserInput(input);
  };

  const registerHandler = (event) => {
    event.preventDefault();
    const submit = event.target;
    submit.disabled = true;
    if (checkInputValidity()) {
      const info = userInput;

      const registerObject = {
        email: info.reg_email,
        first_name: info.reg_first_name,
        last_name: info.reg_last_name,
        agency_name: info.reg_agency_name,
        agency_affiliation: info.reg_agency_affiliation,
        country: info.reg_country,
      };

      DataHandler.matchAppId().then((appId) => {
        APIHandler.setUser(info.reg_email, appId, registerObject).then(() => {
          APIHandler.getUserOld(appId, info.reg_email).then((newUser) => {
            if (newUser.result === 'success') {
              toast.success(
                'Registration successful, please check your email to confirm your account. You can now close this window.',
                {
                  position: 'top-center',
                  transition: Zoom,
                  autoClose: 10000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                }
              );
            }
            return newUser;
          });
          submit.disabled = false;
        });
      });
    } else {
      const invalidFields = `Please fill in all the required fields: ${checkInputValidityFields().join(
        ', '
      )}`;
      toast.error(invalidFields, {
        position: 'top-center',
        transition: Zoom,
        autoClose: 10000,
        hideProgressBar: true,
        pauseOnHover: true,
        draggable: true,
      });
      submit.disabled = false;
    }
  };

  const getLogo = async () => {
    const appInfo = await StorageHandler.load(storageKeys.appInfo);
    if (appInfo) {
      setLogo(appInfo.logo);
    }
  };

  useEffect(() => {
    getLogo();
  });

  return (
    <div className="preRegisterView">
      <BackImage />
      <div className="preRegisterView__wrapper">
        <img src={logo} alt="Monaco Expert" className="preRegisterView__logo" />
        <h3>Coming Soon:</h3>
        <h1>The new Monaco Expert</h1>
        <hr className="shortLine" />
        <p>
          While your clients have been dreaming about monaco, we’ve been
          dreaming about a brand-new exciting way to help you, our loyal travel
          advisors, make their dreams a reality.
        </p>
        <p>
          And we’re thrilled to tell you it’s coming soon to a computer, tablet,
          and phone near you.
        </p>
        <p>
          This cutting-edge, mobile-ready platform will help you Train, Retain,
          Promote and Sell Monaco like never before with high-tech tools
          to learn more, share more, and book more — anytime, anywhere, and from
          any device.
        </p>
        <p>
          Just complete the form below and you’ll be the first to know when the
          program launches.
        </p>
        <p>
          If you’re looking to log your bookings into monaco Rewards, no
          problem! Just <Link to="/rewards">click here</Link>.
        </p>
        <hr className="shortLine" />

        <div className="preRegisterView__form">
          <div className="preRegisterView__form--inputfield">
            <label htmlFor="reg_email" id="reg_email">
              Email *
            </label>
            <input
              id="reg_email"
              name="reg_email"
              type="email"
              placeholder="Email"
              onChange={changeHandler}
              required
            />
          </div>
          <div className="preRegisterView__form--inputfield">
            <label htmlFor="reg_first_name" id="reg_first_name">
              First Name *
            </label>
            <input
              id="reg_first_name"
              name="reg_first_name"
              type="text"
              placeholder="First Name"
              onChange={changeHandler}
              required
            />
          </div>
          <div className="preRegisterView__form--inputfield">
            <label htmlFor="reg_last_name" id="reg_last_name">
              Last Name *
            </label>
            <input
              id="reg_last_name"
              name="reg_last_name"
              type="text"
              placeholder="Last Name"
              onChange={changeHandler}
              required
            />
          </div>
          <div className="preRegisterView__form--inputfield">
            <label htmlFor="reg_agency_name" id="reg_agency_name">
              Agency Name *
            </label>
            <input
              id="reg_agency_name"
              name="reg_agency_name"
              type="text"
              placeholder="Agency Name"
              onChange={changeHandler}
              required
            />
          </div>
          <div className="preRegisterView__form--inputfield">
            <label htmlFor="reg_agency_affiliation" id="reg_agency_affiliation">
              Consortia Affiliation *
            </label>
            <select
              id="reg_agency_affiliation"
              name="reg_agency_affiliation"
              onChange={changeHandler}
              required
            >
              <option value="" disabled selected>
                Please select an option below
              </option>
              <option value="AAA">AAA</option>
              <option value="Affluent Traveler Collection">
                Affluent Traveler Collection
              </option>
              <option value="American Express">American Express</option>
              <option value="Avoya Travel">Avoya Travel</option>
              <option value="CAA">CAA</option>
              <option value="Carlson Wagonlit Travel">
                Carlson Wagonlit Travel
              </option>
              <option value="CCRA">CCRA</option>
              <option value="Cruise Planners">Cruise Planners</option>
              <option value="Ensemble Travel">Ensemble Travel</option>
              <option value="Expedia Group">Expedia Group</option>
              <option value="GSM">GSM</option>
              <option value="Leisure Travel Alliance">
                Leisure Travel Alliance
              </option>
              <option value="Liberty Travel">Liberty Travel</option>
              <option value="MAST">MAST</option>
              <option value="Nest">Nest</option>
              <option value="OASIS Travel Network">OASIS Travel Network</option>
              <option value="RADIUS">RADIUS</option>
              <option value="Rovia">Rovia</option>
              <option value="Signature">Signature</option>
              <option value="THOR">THOR</option>
              <option value="Travel Leaders Network">
                Travel Leaders Network
              </option>
              <option value="Travel Planners International">
                Travel Planners International
              </option>
              <option value="TRAVELSAVERS">TRAVELSAVERS</option>
              <option value="Uniglobe">Uniglobe</option>
              <option value="Virtuoso">Virtuoso</option>
              <option value="WESTA">WESTA</option>
              <option value="World Travel Holdings">
                World Travel Holdings
              </option>
              <option value="NONE">None</option>
              <option value="OTHER">OTHER</option>
            </select>
          </div>
          <div className="preRegisterView__form--inputfield">
            <label htmlFor="reg_country" id="reg_country">
              Country *
            </label>
            <select
              id="reg_country"
              name="reg_country"
              onChange={changeHandler}
              required
            >
              <option value="" disabled selected>
                Please select an option below
              </option>
              <option value="Afghanistan">Afghanistan</option>
              <option value="Åland Islands">Åland Islands</option>
              <option value="Albania">Albania</option>
              <option value="Algeria">Algeria</option>
              <option value="American Samoa">American Samoa</option>
              <option value="Andorra">Andorra</option>
              <option value="Angola">Angola</option>
              <option value="Anguilla">Anguilla</option>
              <option value="Antarctica">Antarctica</option>
              <option value="Antigua and Barbuda">Antigua and Barbuda</option>
              <option value="Argentina">Argentina</option>
              <option value="Armenia">Armenia</option>
              <option value="Aruba">Aruba</option>
              <option value="Australia">Australia</option>
              <option value="Austria">Austria</option>
              <option value="Azerbaijan">Azerbaijan</option>
              <option value="Bahamas">Bahamas</option>
              <option value="Bahrain">Bahrain</option>
              <option value="Bangladesh">Bangladesh</option>
              <option value="Barbados">Barbados</option>
              <option value="Belarus">Belarus</option>
              <option value="Belgium">Belgium</option>
              <option value="Belize">Belize</option>
              <option value="Benin">Benin</option>
              <option value="Bermuda">Bermuda</option>
              <option value="Bhutan">Bhutan</option>
              <option value="Bolivia">Bolivia</option>
              <option value="Bosnia and Herzegovina">
                Bosnia and Herzegovina
              </option>
              <option value="Botswana">Botswana</option>
              <option value="Bouvet Island">Bouvet Island</option>
              <option value="Brazil">Brazil</option>
              <option value="British Indian Ocean Territory">
                British Indian Ocean Territory
              </option>
              <option value="Brunei Darussalam">Brunei Darussalam</option>
              <option value="Bulgaria">Bulgaria</option>
              <option value="Burkina Faso">Burkina Faso</option>
              <option value="Burundi">Burundi</option>
              <option value="Cambodia">Cambodia</option>
              <option value="Cameroon">Cameroon</option>
              <option value="Canada">Canada</option>
              <option value="Cape Verde">Cape Verde</option>
              <option value="Cayman Islands">Cayman Island</option>
              <option value="Central African Republic">
                Central African Republic
              </option>
              <option value="Chad">Chad</option>
              <option value="Chile">Chile</option>
              <option value="China">China</option>
              <option value="Christmas Island">Christmas Island</option>
              <option value="Cocos (Keeling) Islands">
                Cocos (Keeling) Islands
              </option>
              <option value="Colombia">Colombia</option>
              <option value="Comoros">Comoros</option>
              <option value="Congo">Congo</option>
              <option value="Congo, The Democratic Republic of The">
                Congo, The Democratic Republic of The
              </option>
              <option value="Cook Islands">Cook Islands</option>
              <option value="Costa Rica">Costa Rica</option>
              <option value="Cote D'ivoire">Cote D'ivoire</option>
              <option value="Croatia">Croatia</option>
              <option value="Cuba">Cuba</option>
              <option value="Cyprus">Cyprus</option>
              <option value="Czech Republic">Czech Republic</option>
              <option value="Denmark">Denmark</option>
              <option value="Djibouti">Djibouti</option>
              <option value="Dominica">Dominica</option>
              <option value="Dominican Republic">Dominican Republic</option>
              <option value="Ecuador">Ecuador</option>
              <option value="Egypt">Egypt</option>
              <option value="El Salvador">El Salvador</option>
              <option value="Equatorial Guinea">Equatorial Guinea</option>
              <option value="Eritrea">Eritrea</option>
              <option value="Estonia">Estonia</option>
              <option value="Ethiopia">Ethiopia</option>
              <option value="Falkland Islands (Malvinas)">
                Falkland Islands (Malvinas)
              </option>
              <option value="Faroe Islands">Faroe Islands</option>
              <option value="Fiji">Fiji</option>
              <option value="Finland">Finland</option>
              <option value="France">France</option>
              <option value="French Guiana">French Guiana</option>
              <option value="French Polynesia">French Polynesia</option>
              <option value="French Southern Territories">
                French Southern Territories
              </option>
              <option value="Gabon">Gabon</option>
              <option value="Gambia">Gambia</option>
              <option value="Georgia">Georgia</option>
              <option value="Germany">Germany</option>
              <option value="Ghana">Ghana</option>
              <option value="Gibraltar">Gibraltar</option>
              <option value="Greece">Greece</option>
              <option value="Greenland">Greenland</option>
              <option value="Grenada">Grenada</option>
              <option value="Guadeloupe">Guadeloupe</option>
              <option value="Guam">Guam</option>
              <option value="Guatemala">Guatemala</option>
              <option value="Guernsey">Guernsey</option>
              <option value="Guinea">Guinea</option>
              <option value="Guinea-bissau">Guinea-bissau</option>
              <option value="Guyana">Guyana</option>
              <option value="Haiti">Haiti</option>
              <option value="Heard Island and Mcdonald Islands">
                Heard Island and Mcdonald Islands
              </option>
              <option value="Holy See (Vatican City State)">
                Holy See (Vatican City State)
              </option>
              <option value="Honduras">Honduras</option>
              <option value="Hong Kong">Hong Kong</option>
              <option value="Hungary">Hungary</option>
              <option value="Iceland">Iceland</option>
              <option value="India">India</option>
              <option value="Indonesia">Indonesia</option>
              <option value="Iran, Islamic Republic of">
                Iran, Islamic Republic of
              </option>
              <option value="Iraq">Iraq</option>
              <option value="Ireland">Ireland</option>
              <option value="Isle of Man">Isle of Man</option>
              <option value="Israel">Israel</option>
              <option value="Italy">Italy</option>
              <option value="Jamaica">Jamaica</option>
              <option value="Japan">Japan</option>
              <option value="Jersey">Jersey</option>
              <option value="Jordan">Jordan</option>
              <option value="Kazakhstan">Kazakhstan</option>
              <option value="Kenya">Kenya</option>
              <option value="Kiribati">Kiribati</option>
              <option value="Korea, Democratic People's Republic of">
                Korea, Democratic People's Republic of
              </option>
              <option value="Korea, Republic of">Korea, Republic of</option>
              <option value="Kuwait">Kuwait</option>
              <option value="Kyrgyzstan">Kyrgyzstan</option>
              <option value="Lao People's Democratic Republic">
                Lao People's Democratic Republic
              </option>
              <option value="Latvia">Latvia</option>
              <option value="Lebanon">Lebanon</option>
              <option value="Lesotho">Lesotho</option>
              <option value="Liberia">Liberia</option>
              <option value="Libyan Arab Jamahiriya">
                Libyan Arab Jamahiriya
              </option>
              <option value="Liechtenstein">Liechtenstein</option>
              <option value="Lithuania">Lithuania</option>
              <option value="Luxembourg">Luxembourg</option>
              <option value="Macao">Macao</option>
              <option value="Macedonia, The Former Yugoslav Republic of">
                Macedonia, The Former Yugoslav Republic of
              </option>
              <option value="Madagascar">Madagascar</option>
              <option value="Malawi">Malawi</option>
              <option value="Malaysia">Malaysia</option>
              <option value="Maldives">Maldives</option>
              <option value="Mali">Mali</option>
              <option value="Malta">Malta</option>
              <option value="Marshall Islands">Marshall Islands</option>
              <option value="Martinique">Martinique</option>
              <option value="Mauritania">Mauritania</option>
              <option value="Mauritius">Mauritius</option>
              <option value="Mayotte">Mayotte</option>
              <option value="Mexico">Mexico</option>
              <option value="Micronesia, Federated States of">
                Micronesia, Federated States of
              </option>
              <option value="Moldova, Republic of">Moldova, Republic of</option>
              <option value="Monaco">Monaco</option>
              <option value="Mongolia">Mongolia</option>
              <option value="Montenegro">Montenegro</option>
              <option value="Montserrat">Montserrat</option>
              <option value="Morocco">Morocco</option>
              <option value="Mozambique">Mozambique</option>
              <option value="Myanmar">Myanmar</option>
              <option value="Namibia">Namibia</option>
              <option value="Nauru">Nauru</option>
              <option value="Nepal">Nepal</option>
              <option value="Netherlands">Netherlands</option>
              <option value="Netherlands Antilles">Netherlands Antilles</option>
              <option value="New Caledonia">New Caledonia</option>
              <option value="New Zealand">New Zealand</option>
              <option value="Nicaragua">Nicaragua</option>
              <option value="Niger">Niger</option>
              <option value="Nigeria">Nigeria</option>
              <option value="Niue">Niue</option>
              <option value="Norfolk Island">Norfolk Island</option>
              <option value="Northern Mariana Islands">
                Northern Mariana Islands
              </option>
              <option value="Norway">Norway</option>
              <option value="Oman">Oman</option>
              <option value="Pakistan">Pakistan</option>
              <option value="Palau">Palau</option>
              <option value="Palestinian Territory, Occupied">
                Palestinian Territory, Occupied
              </option>
              <option value="Panama">Panama</option>
              <option value="Papua New Guinea">Papua New Guinea</option>
              <option value="Paraguay">Paraguay</option>
              <option value="Peru">Peru</option>
              <option value="Philippines">Philippines</option>
              <option value="Pitcairn">Pitcairn</option>
              <option value="Poland">Poland</option>
              <option value="Portugal">Portugal</option>
              <option value="Puerto Rico">Puerto Rico</option>
              <option value="Qatar">Qatar</option>
              <option value="Reunion">Reunion</option>
              <option value="Romania">Romania</option>
              <option value="Russian Federation">Russian Federation</option>
              <option value="Rwanda">Rwanda</option>
              <option value="Saint Helena">Saint Helena</option>
              <option value="Saint Kitts and Nevis">
                Saint Kitts and Nevis
              </option>
              <option value="Saint Lucia">Saint Lucia</option>
              <option value="Saint Pierre and Miquelon">
                Saint Pierre and Miquelon
              </option>
              <option value="Saint Vincent and The Grenadines">
                Saint Vincent and The Grenadines
              </option>
              <option value="Samoa">Samoa</option>
              <option value="San Marino">San Marino</option>
              <option value="Sao Tome and Principe">
                Sao Tome and Principe
              </option>
              <option value="Saudi Arabia">Saudi Arabia</option>
              <option value="Senegal">Senegal</option>
              <option value="Serbia">Serbia</option>
              <option value="Seychelles">Seychelles</option>
              <option value="Sierra Leone">Sierra Leone</option>
              <option value="Singapore">Singapore</option>
              <option value="Slovakia">Slovakia</option>
              <option value="Slovenia">Slovenia</option>
              <option value="Solomon Islands">Solomon Islands</option>
              <option value="Somalia">Somalia</option>
              <option value="South Africa">South Africa</option>
              <option value="South Georgia and The South Sandwich Islands">
                South Georgia and The South Sandwich Islands
              </option>
              <option value="Spain">Spain</option>
              <option value="Sri Lanka">Sri Lanka</option>
              <option value="Sudan">Sudan</option>
              <option value="Suriname">Suriname</option>
              <option value="Svalbard and Jan Mayen">
                Svalbard and Jan Mayen
              </option>
              <option value="Swaziland">Swaziland</option>
              <option value="Sweden">Sweden</option>
              <option value="Switzerland">Switzerland</option>
              <option value="Syrian Arab Republic">Syrian Arab Republic</option>
              <option value="Taiwan">Taiwan</option>
              <option value="Tajikistan">Tajikistan</option>
              <option value="Tanzania, United Republic of">
                Tanzania, United Republic of
              </option>
              <option value="Thailand">Thailand</option>
              <option value="Timor-leste">Timor-leste</option>
              <option value="Togo">Togo</option>
              <option value="Tokelau">Tokelau</option>
              <option value="Tonga">Tonga</option>
              <option value="Trinidad and Tobago">Trinidad and Tobago</option>
              <option value="Tunisia">Tunisia</option>
              <option value="Turkey">Turkey</option>
              <option value="Turkmenistan">Turkmenistan</option>
              <option value="Turks and Caicos Islands">
                Turks and Caicos Islands
              </option>
              <option value="Tuvalu">Tuvalu</option>
              <option value="Uganda">Uganda</option>
              <option value="Ukraine">Ukraine</option>
              <option value="United Arab Emirates">United Arab Emirates</option>
              <option value="United Kingdom">United Kingdom</option>
              <option value="United States">United States</option>
              <option value="United States Minor Outlying Islands">
                United States Minor Outlying Islands
              </option>
              <option value="Uruguay">Uruguay</option>
              <option value="Uzbekistan">Uzbekistan</option>
              <option value="Vanuatu">Vanuatu</option>
              <option value="Venezuela">Venezuela</option>
              <option value="Viet Nam">Viet Nam</option>
              <option value="Virgin Islands, British">
                Virgin Islands, British
              </option>
              <option value="Virgin Islands, U.S.">Virgin Islands, U.S.</option>
              <option value="Wallis and Futuna">Wallis and Futuna</option>
              <option value="Western Sahara">Western Sahara</option>
              <option value="Yemen">Yemen</option>
              <option value="Zambia">Zambia</option>
              <option value="Zimbabwe">Zimbabwe</option>
            </select>
          </div>
          <div className="disclaimer">
            <p>* Required fields</p>
          </div>
          <div className="preRegisterView__form--button">
            <button
              type="submit"
              name="subscribe"
              id="submit"
              onClick={registerHandler}
            >
              Submit
            </button>
          </div>
          <ToastContainer draggablePercent={70} />
        </div>
      </div>
    </div>
  );
};

export default PreRegisterView;
